export function loadAiTranslatePlugin() {
  const translations = {
    en: {
      item1: 'English',
      item2: 'German (Sie)',
      item3: 'German (du)',
      item4: 'French',
      item5: 'Spanish',
      item6: 'Italian',
      item7: 'Polish',
      item8: 'Romanian',
      item9: 'Czech',
      item10: 'Dutch',
      item11: 'Turkish',
      item12: 'Ukrainian'
    },
    fr: {
      item1: 'Anglais',
      item2: 'Allemand (Sie)',
      item3: 'Allemand (du)',
      item4: 'Français',
      item5: 'Espagnol',
      item6: 'Italien',
      item7: 'Polonais',
      item8: 'Roumain',
      item9: 'Tchèque',
      item10: 'Néerlandais',
      item11: 'Turc',
      item12: 'Ukrainien'
    },
    es: {
      item1: 'Inglés',
      item2: 'Alemán (Sie)',
      item3: 'Alemán (du)',
      item4: 'Francés',
      item5: 'Español',
      item6: 'Italiano',
      item7: 'Polaco',
      item8: 'Rumano',
      item9: 'Checo',
      item10: 'Neerlandés',
      item11: 'Turco',
      item12: 'Ucraniano'
    },
    de: {
      item1: 'Englisch',
      item2: 'Deutsch (Sie)',
      item3: 'Deutsch (du)',
      item4: 'Französisch',
      item5: 'Spanisch',
      item6: 'Italienisch',
      item7: 'Polnisch',
      item8: 'Rumänisch',
      item9: 'Tschechisch',
      item10: 'Niederländisch',
      item11: 'Türkisch',
      item12: 'Ukrainisch'
    },
    it: {
      item1: 'Inglese',
      item2: 'Tedesco (Sie)',
      item3: 'Tedesco (du)',
      item4: 'Francese',
      item5: 'Spagnolo',
      item6: 'Italiano',
      item7: 'Polacco',
      item8: 'Rumeno',
      item9: 'Ceco',
      item10: 'Olandese',
      item11: 'Turco',
      item12: 'Ucraino'
    },
    pl: {
      item1: 'Angielski',
      item2: 'Niemiecki (Sie)',
      item3: 'Niemiecki (du)',
      item4: 'Francuski',
      item5: 'Hiszpański',
      item6: 'Włoski',
      item7: 'Polski',
      item8: 'Rumuński',
      item9: 'Czeski',
      item10: 'Niderlandzki',
      item11: 'Turecki',
      item12: 'Ukraiński'
    },
    ro: {
      item1: 'Engleză',
      item2: 'Germană (Sie)',
      item3: 'Germană (du)',
      item4: 'Franceză',
      item5: 'Spaniolă',
      item6: 'Italiană',
      item7: 'Poloneză',
      item8: 'Română',
      item9: 'Cehă',
      item10: 'Olandeză',
      item11: 'Turcă',
      item12: 'Ucraineană'
    },
    cz: {
      item1: 'Anglický',
      item2: 'Německý (Sie)',
      item3: 'Německý (du)',
      item4: 'Francouzský',
      item5: 'Španělský',
      item6: 'Italský',
      item7: 'Polský',
      item8: 'Rumunský',
      item9: 'Český',
      item10: 'Nizozemský',
      item11: 'Turecký',
      item12: 'Ukrajinský'
    },
    nl: {
      item1: 'Engels',
      item2: 'Duits (Sie)',
      item3: 'Duits (du)',
      item4: 'Frans',
      item5: 'Spaans',
      item6: 'Italiaans',
      item7: 'Pools',
      item8: 'Roemeens',
      item9: 'Tsjechisch',
      item10: 'Nederlands',
      item11: 'Turks',
      item12: 'Oekraïens'
    },
    tr: {
      item1: 'İngilizce',
      item2: 'Almanca (Sie)',
      item3: 'Almanca (du)',
      item4: 'Fransızca',
      item5: 'İspanyolca',
      item6: 'İtalyanca',
      item7: 'Lehçe',
      item8: 'Rumence',
      item9: 'Çekçe',
      item10: 'Hollandaca',
      item11: 'Türkçe',
      item12: 'Ukraynaca'
    },
    uk: {
      item1: 'Англійська',
      item2: 'Німецька (Sie)',
      item3: 'Німецька (du)',
      item4: 'Французька',
      item5: 'Іспанська',
      item6: 'Італійська',
      item7: 'Польська',
      item8: 'Румунська',
      item9: 'Чеська',
      item10: 'Нідерландська',
      item11: 'Турецька',
      item12: 'Українська'
    }
  };

  FroalaEditor.PLUGINS.aiTranslate = function (editor) {
    return {
      dropdownCallback: function (cmd, val) {
        const options = FroalaEditor.COMMANDS['aiTranslate'].options();
        const languageLabel = options[val];
        editor.events.trigger('aiTranslate.itemClicked', [languageLabel]);
      }
    };
  };

  FroalaEditor.DefineIcon('translateIcon', {
    SRC: '/assets/images/froala-plugins/translate.icon.png',
    ALT: 'Translate',
    template: 'image'
  });

  FroalaEditor.RegisterCommand('aiTranslate', {
    title: 'Translate',
    type: 'dropdown',
    icon: 'translateIcon',

    options: function () {
      const editor = FroalaEditor.INSTANCES[0];
      const lang = editor?.opts?.language || 'en';
      return translations[lang] || translations['en'];
    },

    callback: function (cmd, val) {
      this.aiTranslate.dropdownCallback(cmd, val);
    },

    refresh: function ($btn) {
      const selectedText = this.selection?.get()?.toString() || '';
      if (!selectedText.trim()) {
        $btn.addClass('fr-disabled');
      } else {
        $btn.removeClass('fr-disabled');
      }
    }
  });
}
